<ng-container [formGroup]="formGroup">
    <td>
        <div class="checkbox-container">
            <input
                type="checkbox"
                class="form-control"
                #checkbox
                id="document-select-checkbox"
                formControlName="checkbox"
                (click)="selectDocument()"
                [attr.aria-label]="'DOCBOX_SELECT_DOC_ARIA_LABEL' | translate"
            />
            @if (document.isFileSelected) {
                <fa-icon [icon]="faCheck" size="2x" (click)="checkbox.click()"></fa-icon>
            }
        </div>
    </td>
    <td class="type-column">
        <span class="type-icon"><fa-icon [icon]="document.docType | docBoxListIcon"></fa-icon></span>
        {{ document.docType }}
        @if (document.reportType | docBoxReportType; as reportTypeKey) {
            <div class="report-type text-muted small">{{ reportTypeKey | translate }}</div>
        }
    </td>
    <td class="type-column">{{ document.title }}</td>
    <td class="type-column">{{ document.printNumber }}</td>
    <td class="type-column">{{ document.date || 'null' }}</td>
    <td class="type-column">{{ document.createdBy }}</td>
    <td class="type-column">{{ document.orderNumber }}</td>
    <td class="type-column">{{ document.reportStatus }}</td>
    <td class="type-column">{{ document.fileType }}</td>
    <td>
        @if (enableIndividualDownload) {
            <button
                class="btn btn-small btn-secondary me-1 mb-2"
                #tooltip="bs-tooltip"
                [tooltip]="'DOCBOX_DOWNLOAD_DOCUMENT_TOOLTIP' | translate"
                (click)="downloadDocument()"
                [attr.aria-label]="'DOCBOX_DOWNLOAD_DOCUMENT_TOOLTIP' | translate"
            >
                <fa-icon [icon]="faSave"></fa-icon>
            </button>
        }
        <button
            class="btn btn-small btn-secondary me-1 mb-2"
            #tooltip="bs-tooltip"
            [tooltip]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP_FOR_ENTRY' | translate"
            placement="left"
            (click)="uploadForEntry()"
            [attr.aria-label]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP_FOR_ENTRY' | translate"
        >
            <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
        </button>
    </td>
</ng-container>
